import React from 'react';
import './error.css';

export default class Result extends React.Component {
  render() {
    return (
      <div className="Error">
         {this.props.error ? <h2 style={{fontStyle: 'italic'}}>Oops, we got an error: {this.props.code}</h2> : null}
         <h1>{this.props.status}</h1>
        <p style={{color:'#ffcccc'}}>{this.props.message}</p>
      </div>
    );
  }
}